// extracted by mini-css-extract-plugin
module.exports = {"table_price":"summary_table_price__3ZzLW","mounth":"summary_mounth__1ogxm","price":"summary_price__Gwkxi","orange":"summary_orange__2Obie","tr":"summary_tr__pc2rL"};